<script setup>
defineProps({
  emptyKey: {
    type: String,
    required: true,
  },
  backgroundColor: {
    type: String,
    required: true,
    default: '#0079D0',
  },
  icon: {
    type: String,
    required: true,
    default: 'running',
  },
  iconType: {
    type: String,
    required: false,
    default: 'far',
  },
  isExternal: {
    type: Boolean,
    required: false,
    default: false,
  },
});
</script>

<template>
  <div class="flex flex-col h-full justify-center items-center">
    <img
      :src="`/img/emptyWidgets/${emptyKey.toLowerCase()}.svg`"
      class="h-[180px] w-[234px]"
    />

    <div class="flex flex-col items-center pt-10">
      <!-- Only show icon if not external module, to not mix e.g 'pulsen' with normal activity icon -->
      <fa-icon
        v-if="!isExternal"
        :icon="[`${iconType}`, `${icon}`]"
        class="text-3xl"
        :style="{ color: `${backgroundColor}` }"
      />
      <p
        class="flex h900 justify-center pt-5"
        :style="{ color: `${backgroundColor}` }"
      >
        {{ $t(`emptyStates.${emptyKey}`) }}
      </p>
    </div>
  </div>
</template>
